import TextBins from "./textbins";

export default TextBins;